define( [ 'utility' ], function run( utility ) {
	'use strict';

	var aTextboxFormatFn = {

		defaults : {
			maxgaps : 2,
			maxlength : 8,
			spacer : '/',
			formats : {
				twotwo : {
					format : '22',
					gaps : [ 2 ],
					length : 4,
				},
				twofour : {
					format : '24',
					gaps : [ 2 ],
					length : 6,
				},
				twotwotwo : {
					format : '222',
					gaps : [ 2, 4 ],
					length : 6,
				},
				twotwofour : {
					format : '224',
					gaps : [ 2, 4 ],
					length : 8,
				},
				fourtwotwo : {
					format : '422',
					gaps : [ 4, 6 ],
					length : 8,
				},
				pin : {
					format : 'pin',
					gaps : [ 1, 2, 3 ],
					length : 4,
				},
				sortcode : {
					format : 'sortcode',
					gaps : [ 2, 4 ],
					length : 6,
				},
			},
			separatorLookup : {
				'/' : '/',
				'-' : '-',
				'.' : '\\.',
				',' : ',',
				' ' : ' ',
				':' : ':',
				'\\' : '\\\\',
				'*' : '\\*',
			},
		},

		init : function( elm ) {
			var formatDebounce;

			if ( !elm.classList.contains( 'js-a-textbox-format' ) ) {
				elm.classList.add( 'js-a-textbox-format' );

				elm.aTextboxFormat = {}; // Setup aTextboxFormat object
				// Get defaults from above and add/update any specified data-attribute options in html
				elm.aTextboxFormat.settings = utility.extend({}, aTextboxFormatFn.defaults, utility.getData( elm ) );

				Object.keys( elm.aTextboxFormat.settings.formats ).forEach( function loop( formatName ) {
					if ( elm.aTextboxFormat.settings.formats[ formatName ].format === elm.aTextboxFormat.settings.format.toString() ) {
						// All the action happens here!
						elm.aTextboxFormat.currentFormat = elm.aTextboxFormat.settings.formats[ formatName ];
					}
				});

				if ( elm.aTextboxFormat.currentFormat ) {
					elm.value = elm.value || '';
					elm.aTextboxFormat.currentVal = elm.value;
					elm.aTextboxFormat.currentSettings = elm.aTextboxFormat.settings;

					// Prevent anything other than number, space or - unless ctrl of apple cmd key are also pressed
					elm.addEventListener( 'keydown', function listener( e ) {
						var regEx = RegExp( '([0-9]|ArrowLeft|ArrowRight|ArrowDown|ArrowUp|Left|Right|Down|Up|Backspace|Delete|Del|Tab|' +
							elm.aTextboxFormat.settings.separatorLookup[ elm.aTextboxFormat.settings.spacer ] + ')+' ),
							ctrl = e.ctrlKey || e.metaKey; // Ctrl or Mac CMD

						if ( regEx.test( e.key ) || ctrl ) {
							// Do nothing
						} else {
							e.preventDefault();
						}
					});

					formatDebounce = utility.debounce( function listener( e ) {
						var regEx = RegExp( '[0-9]|ArrowLeft|ArrowRight|ArrowDown|ArrowUp|Left|Right|Down|Up|Backspace|Delete|Del|' +
							elm.aTextboxFormat.settings.separatorLookup[ elm.aTextboxFormat.settings.spacer ] ),
							newVal;

						// Do not format if the caret is not at the end of the textbox ie. editing
						if ( regEx.test( e.key ) && elm.selectionStart === elm.selectionEnd && elm.selectionEnd === elm.value.length ) {
							newVal = aTextboxFormatFn.formatTextbox( elm, elm.value, elm.aTextboxFormat.currentSettings );
							elm.value = newVal; // Format the value of the textbox number
							elm.aTextboxFormat.currentVal = newVal; // Store adjusted value
							elm.setSelectionRange( newVal.length, newVal.length ); // Set the caret to the end of the field
						}
					}, 150 );
					elm.addEventListener( 'keyup', formatDebounce );

					elm.addEventListener( 'focusout', function listener() {
						// On blur, make sure the correct format is set and the number is formatted appropriately
						var newTextboxEntry = aTextboxFormatFn.formatTextbox( elm, elm.value, elm.aTextboxFormat.currentSettings );
						elm.value = newTextboxEntry; // Format the value of the textbox number
						elm.aTextboxFormat.currentVal = newTextboxEntry; // Store adjusted value
					});

					// Process input just in case there is already a value present
					elm.value = aTextboxFormatFn.formatTextbox( elm, elm.value, elm.aTextboxFormat.currentSettings );
				}

				elm.aTextboxFormat.setValue = function setValue( newValue ) {
					var newVal = aTextboxFormatFn.formatTextbox( elm, newValue, elm.aTextboxFormat.currentSettings );
					elm.value = newVal; // Format the value of the textbox number
					elm.aTextboxFormat.currentVal = newVal; // Store adjusted value
					utility.trigger( elm, 'change' );
				};

				elm.aTextboxFormat.clear = function clear() {
					elm.value = '';
					elm.aTextboxFormat.currentVal = '';
					utility.trigger( elm, 'change' );
				};
			}

			return elm.aTextboxFormat;
		},

		formatTextbox : function( elm, content, settings ) {
			// Strip out any spaces/dashes/slashes/fullstops/commas
			var unformatedContent = content.replace( /\s/g, '' )
					.replace( /-/g, '' )
					.replace( /\//g, '' )
					.replace( /\./g, '' )
					.replace( /,/g, '' ),
				newContent = [],
				offsets = [],
				i,
				start,
				end,
				lastOffset,
				maxLength;

			if ( unformatedContent.length && unformatedContent.match( /^([0-9]+)$/ ) ) {
				offsets = [].concat( 0, elm.aTextboxFormat.currentFormat.gaps, unformatedContent.length ); // Get offsets for the format type

				// Loop through and build up formatted textbox number by adding in spacers at the correct points
				for ( i = 0; offsets[ i ] < unformatedContent.length; i++ ) {
					start = offsets[ i ];
					end = Math.min( offsets[ i + 1 ], unformatedContent.length );
					newContent.push( unformatedContent.substring( start, end ) );
				}
				lastOffset = elm.aTextboxFormat.currentFormat.gaps[ newContent.length - 1 ];
				newContent = newContent.join( settings.spacer );
				if ( content.substring( content.length - 1, content.length ) === settings.spacer && lastOffset && unformatedContent.length === lastOffset ) {
					newContent += settings.spacer;
				}
			} else {
				newContent = content;
			}
			// Trim to maxlength if rapid typing allows field to overexpand
			maxLength = elm.getAttribute( 'maxlength' );
			if ( newContent.length > maxLength ) {
				newContent = newContent.substring( 0, maxLength );
			}

			return newContent;
		},
	};

	return {
		initInstance : function( elm ) {
			return aTextboxFormatFn.init( elm );
		},
	};
});
